import { signal } from '@preact/signals-react';
import { normalizeText } from './conversation-utils';

export class ConversationRoute {
  readonly conversationId = signal<string | null>(null);

  set(conversationId: string | null | undefined) {
    this.conversationId.value = normalizeText(conversationId);
  }

  reset() {
    this.conversationId.value = null;
  }
}
